var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m6-3a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .276.447l2 1a.5.5 0 1 0 .448-.894L6.5 5.69z",
    clipRule: "evenodd"
  })));
};
export default SvgClock;